import {
  buildFacilitiesMapLayer,
  HaNContext,
  HaNMapStageContext,
  useFacilitiesModel,
  useHaNMapLayer,
} from "@lib/logic";
import { useRequiredContext } from "@lib/utils";

export const FacilitiesMap = () => {
  const { tab } = useRequiredContext(HaNContext);
  const { floorId } = useRequiredContext(HaNMapStageContext);

  if (tab !== "facilities" || !floorId) return null;

  return <FacilitiesMapLayer floorId={floorId} />;
};

type FacilitiesMapLayerProps = {
  floorId: string;
};

// Builds the tab's layer for the page's one map, which the map stage draws. The rooms and areas are the ones their
// details look up, so each marker opens them.
const FacilitiesMapLayer = ({ floorId }: FacilitiesMapLayerProps) => {
  const { facilities, resources, filterData } = useRequiredContext(HaNContext);
  const { highlightedIds } = useFacilitiesModel();

  const layer = buildFacilitiesMapLayer({
    floorId,
    facilities,
    rooms: resources.filter(r => r.type === "room"),
    areas: filterData.workspaces.allData,
    highlightedIds,
  });

  useHaNMapLayer(layer);

  return null;
};
